import React from "react";
import {
  FormRow,
  FormDashboardLabel as Label,
  FormDashboardInput as Input,
  ImagePickerSidebar,
  Button,
} from "..";
import { useInternationalization } from "../../features/i18n";
import { useViewport } from "../../utils";
import { RequiredLabel } from "../form";

const PartnerExternal = ({
  noImage,
  handleImage,
  handleCancel,
  handleSave,
  updateForm,
  defaultValue = {}
}) => {
  const { isMobile } = useViewport();
  const { translate } = useInternationalization()

  const {
    id,
    name,
    website,
    image
  } = defaultValue

  return (
    <div>
      <FormRow>
        <Label>{translate('GENERAL', 'name')} <RequiredLabel /></Label>
        <Input required className="w-full" name="name" onChange={updateForm} defaultValue={name}/>
      </FormRow>
      <FormRow last={id ? false : true}>
        <Label>Website <RequiredLabel /></Label>
        <Input required className="w-full" name="website" placeholder="https://" onChange={updateForm} defaultValue={website}/>
      </FormRow>
      {
        (id && !noImage) &&
        <FormRow last>
          <Label>Logo</Label>
          <div style={{ maxWidth: isMobile ? "100%" : "150px" }}>
            <ImagePickerSidebar height="150px" onChange={handleImage} defaultValue={image}/>
          </div>
        </FormRow>
      }
      <div className="flex flex-wrap items-center">
        <Button
          style={{ maxWidth: isMobile ? "100%" : "197px" }}
          thin={isMobile ? true : false}
          className="mb-5 lg:mb-0"
          type="button"
          onClick={handleSave}
        >
          {translate('GENERAL', 'save')}
        </Button>
        <div
          className="text-center lg:text-left w-full lg:w-auto text-xs lg:text-sm text-gray-444 underline lg:ml-8 cursor-pointer"
          onClick={handleCancel}
        >
          {translate('GENERAL', 'cancel')}
        </div>
      </div>
    </div>
  );
};

export { PartnerExternal };
